import { formatMoney } from '@betterment/core';
import { Separator } from '@betterment/samba-react';
import { DrawerListRow } from '@betterment/shared-components/src/components/activity/components/drawer/common/DrawerListRow';

import { ActivityItemFragment } from '../../../../../graphql/fragments/activityItem.generated';
import { ActivityItemNode } from '../../../types';
import { ActivityDrawerLayout } from '../common/ActivityDrawerLayout';

export const Other: React.FC<{
  item: Extract<ActivityItemNode | ActivityItemFragment, { __typename: 'ActivityItemOther' }>;
}> = ({ item }) => {
  const { users } = item.subAccount;
  return (
    <ActivityDrawerLayout title={item.description ?? 'Other'} users={users}>
      <DrawerListRow label="Account" value={item.subAccount.legalAccount.displayName ?? ''} />
      <Separator />
      {item.amount && <DrawerListRow label="Amount" value={formatMoney(item.amount)} />}
    </ActivityDrawerLayout>
  );
};
